import styled from 'styled-components';

export const PredictionFormSection = styled.section`
  position: relative;
`;
